import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { onMounted, ref } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { useWecomaIntegration } from "./use-wecoma-integration";
import { pushConsentBarShow, pushAllConsentBar, pushEssentialsConsentBar } from "./use-wecoma-datalayer";
import { useBreakpoints } from "../composables/use-breakpoints";
import { WecomaConstants } from "./wecoma-constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'consent-bar',
  setup(__props) {

const { consentToAllPurposes, redirectToPreferenceCenter, redirectToPrivacyPolicy, consentToOnlyNecessaryPurposes } =
    useWecomaIntegration();

const preferenceCenterLink = `${appSettings["Integrations:Wecoma:Domain"]}?key=${WecomaConstants.WECOMA_CODE}&locale=cs-CZ&authKeys=${WecomaConstants.WECOMA_AUTHKEY}&contexts=consentbar&source=cookiebanner`;

const header = environment.gdpr.gdprHeader;

const text = environment.gdpr.gdprMessage;
const headerMobile = environment.gdpr.gdprHeaderMobile;
const textMobile = environment.gdpr.gdprMessageMobile;
const image = environment.gdpr.gdprImageUrl;

const hidingClass = ref("");
const hide = () => {
    hidingClass.value = "hiding";
    setTimeout(() => {
        hidingClass.value = "hidden";
    }, 500);
};

const consentAll = () => {
    setTimeout(() => {
        consentToAllPurposes();
        pushAllConsentBar();
    }, 0);
    hide();
};

const consentToOnlyNecessary = () => {
    consentToOnlyNecessaryPurposes();
    pushEssentialsConsentBar();
    hide();
};

const imageVisible = ref(true);
const hideKulicnik = (e) => {
    const sm2 = useBreakpoints("sm2");
    imageVisible.value = sm2.value || e?.target?.scrollTop === 0;
};

onMounted(() => {
    const prefCenterLinkElement = document.getElementById("consent-bar-preference-center") as HTMLAnchorElement;
    const prefCenterLinkElementMobile = document.getElementById(
        "consent-bar-preference-center-mobile"
    ) as HTMLAnchorElement;

    if (prefCenterLinkElement) {
        prefCenterLinkElement.href = preferenceCenterLink;
        prefCenterLinkElement.addEventListener("click", () => redirectToPreferenceCenter("text"));
    }

    if (prefCenterLinkElementMobile) {
        prefCenterLinkElementMobile.href = preferenceCenterLink;
        prefCenterLinkElementMobile.addEventListener("click", () => redirectToPreferenceCenter("text"));
    }

    const privacyPolicyLinkElement = document.getElementById("consent-bar-privacy-policy") as HTMLAnchorElement;
    privacyPolicyLinkElement.addEventListener("click", () => redirectToPrivacyPolicy());

    pushConsentBarShow();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["consent-bar", hidingClass.value]),
    "data-test": "consent-bar"
  }, [
    (imageVisible.value)
      ? (_openBlock(), _createBlock(WebpImage, {
          key: 0,
          src: _unref(image),
          alt: "cookie lišta",
          "css-class": "consent-bar__image"
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "consent-bar__content",
      ref: "contentSection",
      onScroll: hideKulicnik
    }, [
      _createElementVNode("h2", {
        class: "consent-bar__title",
        innerHTML: _unref(header)
      }, null, 8, _hoisted_1),
      _createElementVNode("h2", {
        class: "consent-bar__title consent-bar__title--mobile",
        innerHTML: _unref(headerMobile)
      }, null, 8, _hoisted_2),
      _createElementVNode("div", {
        class: "consent-bar__text",
        innerHTML: _unref(text)
      }, null, 8, _hoisted_3),
      _createElementVNode("div", {
        class: "consent-bar__text consent-bar__text--mobile",
        innerHTML: _unref(textMobile)
      }, null, 8, _hoisted_4)
    ], 544),
    _createElementVNode("div", { class: "consent-bar__actions" }, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-secondary",
        onClick: consentAll
      }, "Souhlasím se vším"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm consent-bar__more",
        onClick: consentToOnlyNecessary
      }, " Pouze nezbytné ")
    ])
  ], 2))
}
}

})